import { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, Link, NavLink, useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';
import HomePage from './pages/HomePage/HomePage';
import PostPage from './pages/PostPage/PostPage';
import AboutPage from './pages/AboutPage/AboutPage';
import './App.css';

function PageViewTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    logEvent(analytics, 'page_view', { page_path: location.pathname });
  }, [location]);
  return null;
}

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setHidden(y > lastScrollY.current && y > 80);
      lastScrollY.current = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`header${hidden ? ' header--hidden' : ''}`}>
      <Link to="/" className="header-brand">
        <div className="header-logo" aria-hidden="true">🍳</div>
        <div className="header-title-block">
          <span className="header-title">Luke's Breakfast Blog</span>
        </div>
      </Link>
      <nav className={`header-nav${menuOpen ? ' open' : ''}`} aria-label="Main navigation">
        {navLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) => 'header-nav-link' + (isActive ? ' active' : '')}
            onClick={() => setMenuOpen(false)}
          >
            {link.label}
          </NavLink>
        ))}
      </nav>
      <button
        className="header-menu-btn"
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((o) => !o)}
      >
        <span className={`hamburger${menuOpen ? ' open' : ''}`} />
      </button>
    </header>
  );
}

function App() {
  return (
    <BrowserRouter>
      <PageViewTracker />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/post/:slug" element={<PostPage />} />
      </Routes>
      <footer className="footer">
        <nav className="footer-nav">
          <Link to="/" className="footer-nav-link">Home</Link>
          <Link to="/about" className="footer-nav-link">About</Link>
          <a href="/feed.xml" className="footer-nav-link">RSS</a>
        </nav>
        <p className="footer-credit">
          Made by <a href="https://lukemccartney.com" className="footer-external-link" target="_blank" rel="noopener noreferrer">Luke McCartney</a>
        </p>
      </footer>
    </BrowserRouter>
  );
}

export default App;
